import { apiLink } from '../../constants/env';
import axiosInstance from '../AxiosInstance';

const apiEvaporador = {
    fetchApi: async (page) => {
        const URL = `${apiLink()}api/evaporador?page=` + page;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();
            })
    },
    getById: async (id) => {
        const URL = `${apiLink()}api/evaporador/` + id;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();
            })
    },
    postApi: async (evaporador) => {
        const URL = `${apiLink()}api/evaporador`;
        return await axiosInstance.post(URL, evaporador)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();
            })
    },
    deleteApi: async (id) => {
        const URL = `${apiLink()}api/evaporador/status/${id}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    putApi: async (id, evaporador) => {
        const URL = `${apiLink()}api/evaporador/${id}`;
        return await axiosInstance.put(URL, evaporador)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    getByAmbienteId: async (id) => {
        const URL = `${apiLink()}api/evaporador/ambiente/${id}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar dados do Evaporador:', error);
                throw new Error();
            })
    },

}

export default apiEvaporador; 